// 📄 DosagePrintTable.tsx
import React from "react";
import { Patient } from "../../types";

const DosagePrintTable = React.forwardRef<HTMLDivElement, { patient: Patient }>(
  ({ patient }, ref) => {
    const getDose = (pill: any, time: string) =>
      pill.dosages.find((d: any) => d[time])?.[time]?.value || "-";

    return (
      <div ref={ref} dir="rtl" style={{ fontFamily: "Arial", padding: 24 }}>
        <h2>שם הדייר: {patient.name}</h2>
        <h4>תאריך: {new Date().toLocaleDateString("he-IL")}</h4>

        <table
          style={{ width: "100%", borderCollapse: "collapse", marginTop: 20 }}>
          <thead>
            <tr>
              <th style={cellStyle}>שם הכדור</th>
              <th style={cellStyle}>בוקר</th>
              <th style={cellStyle}>צהריים</th>
              <th style={cellStyle}>ערב</th>
              <th style={cellStyle}>לילה</th>
              <th style={cellStyle}>SOS</th>
            </tr>
          </thead>
          <tbody>
            {patient.pills.map((pill, idx) => (
              <tr key={idx}>
                <td style={cellStyle}>{pill.dragHebName}</td>
                <td style={cellStyle}>{getDose(pill, "morning")}</td>
                <td style={cellStyle}>{getDose(pill, "noon")}</td>
                <td style={cellStyle}>{getDose(pill, "evening")}</td>
                <td style={cellStyle}>{getDose(pill, "night")}</td>
                <td style={cellStyle}>{pill.isSOS ? "כן" : ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
);

const cellStyle = {
  border: "1px solid black",
  padding: "8px",
  textAlign: "center" as const,
};

export default DosagePrintTable;
